module.exports = __webpack_public_path__ + "img/Best of Italien rot.7b2f3d09.jpg";